export default __webpack_public_path__ + "static/media/fb.6ec6d1bc.png";